import { Languages, BookA, Brain } from 'lucide-react';
import { CuerpoLayout } from '@/components/oposiciones/CuerpoLayout';

export function OposicionesPNLayout() {
  return (
    <CuerpoLayout
      basePath="/app/policia-nacional"
      shortLabel="Policía Nacional"
      badgeImage="/badge-policia-nacional.png"
      accent="sky"
      areaId="policia_nacional"
      downloadsMode="oposiciones_policia_nacional"
      caseLabel="Caso Práctico"
      hideCase
      extraNavItems={[
        { id: 'ingles',       label: 'Inglés',        icon: Languages,     path: '/app/policia-nacional/ingles' },
        { id: 'lengua',       label: 'Ortografía',    icon: BookA,         path: '/app/policia-nacional/lengua' },
        { id: 'psicotecnico', label: 'Psicotécnicos', icon: Brain,         path: '/app/policia-nacional/psicotecnico' },
      ]}
    />
  );
}
